module.exports = __webpack_public_path__ + "static/media/ZG8167_1440.de209977.jpg";